import device from '../util/device';
import allowDash from '../util/allow-dash';
import allowFlash from '../util/allow-flash';
import VideoType from '../constants/video-type';

function resolveVideoType(videoUrls, textUrls, metadata, videoElement) {
    const dashVideoUrl = videoUrls.dashhbbtv || videoUrls.dash264;
    const immersiveDashVideoUrltb = videoUrls['immersive_dash_stereo_tb'];
    const immersiveDashVideoUrllr = videoUrls['immersive_dash_stereo_lr'];
    const immersiveDashVideoUrlMono = videoUrls['immersive_dash_mono'];
    const immersiveHlsVideoUrltb = videoUrls['immersive_hls_stereo_tb'];
    const immersiveHlsVideoUrllr = videoUrls['immersive_hls_stereo_lr'];
    const immersiveHlsVideoUrlMono = videoUrls['immersive_hls_mono'];
    const hlsJsEnabled = !(textUrls.websrt && !textUrls.webvtt) && device.supportsHlsJs();

    const videoTypes = [];

    // DASH and HLS

    if (dashVideoUrl && allowDash(metadata)) {
        videoTypes.push({
            type: VideoType.DASH,
            videoUrl: videoUrls.dashhbbtv || videoUrls.dash264,
            textUrl: textUrls.webvtt
        });
    }

    if (videoUrls.hls && (device.supportsHls(videoElement) || hlsJsEnabled)) {
        videoTypes.push({
            type: VideoType.HLS,
            videoUrl: videoUrls.hls,
            textUrl: textUrls.websrt
        });
    }

    // Flash video

    if (videoUrls.hls && allowFlash()) {
        videoTypes.push({
            type: VideoType.FLASHLS,
            videoUrl: videoUrls.hls,
            textUrl: textUrls.websrt
        });
    }

    if (videoUrls.hds && allowFlash()) {
        videoTypes.push({
            type: VideoType.HDS,
            videoUrl: videoUrls.hds,
            textUrl: textUrls.websrt
        });
    }

    // 360 video

    if (immersiveDashVideoUrltb && allowDash(metadata)) {
        videoTypes.push({
            type: VideoType.IMMERSIVE_DASH_STEREO_TB,
            videoUrl: immersiveDashVideoUrltb,
            textUrl: textUrls.webvtt
        });
    }

    if (immersiveDashVideoUrllr && allowDash(metadata)) {
        videoTypes.push({
            type: VideoType.IMMERSIVE_DASH_STEREO_LR,
            videoUrl: immersiveDashVideoUrllr,
            textUrl: textUrls.webvtt
        });
    }

    if (immersiveDashVideoUrlMono && allowDash(metadata)) {
        videoTypes.push({
            type: VideoType.IMMERSIVE_DASH_MONO,
            videoUrl: immersiveDashVideoUrlMono,
            textUrl: textUrls.webvtt
        });
    }

    if (immersiveHlsVideoUrltb && (device.supportsHls(videoElement) || hlsJsEnabled)) {
        videoTypes.push({
            type: VideoType.IMMERSIVE_HLS_STEREO_TB,
            videoUrl: immersiveHlsVideoUrltb,
            textUrl: textUrls.websrt
        });
    }

    if (immersiveHlsVideoUrllr && (device.supportsHls(videoElement) || hlsJsEnabled)) {
        videoTypes.push({
            type: VideoType.IMMERSIVE_HLS_STEREO_LR,
            videoUrl: immersiveHlsVideoUrllr,
            textUrl: textUrls.websrt
        });
    }

    if (immersiveHlsVideoUrlMono && (device.supportsHls(videoElement) || hlsJsEnabled)) {
        videoTypes.push({
            type: VideoType.IMMERSIVE_HLS_MONO,
            videoUrl: immersiveHlsVideoUrlMono,
            textUrl: textUrls.websrt
        });
    }

    return videoTypes;
}

export default function (videoUrls, textUrls, metadata, videoElement) {
    return resolveVideoType(videoUrls, textUrls, metadata, videoElement);
}



// WEBPACK FOOTER //
// ./src/js/modules/resolve-streaming-config.js